import API from ".";

export const listStates = async () => {
    try {
      const response = await API.get("/master/list_states?sort=state_name&order=asc");
      return response.data;
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  };

export const listTerritory = async (stateId: string[]) => {
    try {
        const response = await API.get(`/master/list_territory?sort=territory_name&order=asc&state_id=${stateId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching users:", error);
        throw error;
    }
};

export const listCluster= async (stateId: string[]) => {
    try {
      const response = await API.get(`/master/list_cluster?sort=cluster_name&order=asc&state_id=${stateId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  };

export const listBranches = async (stateId: string[], highRisk?: string[]) => {
    try {
        const response = await API.get(`/master/list_branches?sort=branch_name&order=asc&state_id=${stateId}&is_high_risk=${highRisk}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching users:", error);
        throw error;
    }
};

export const ProductType = async () => {
  try {
    const response = await API.get("/master/list_product_types?order=asc");
    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const RelationType = async () => {
  try {
    const response = await API.get("/master/list_relation_types?order=asc");
    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const listVintage = async () => {
  try {
    // const response = await API.get("/master/list_quarters?order=asc");
    const response = await API.get("/master/list_financial_quarters?order=asc");
    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};